export default "<p>\r\n  report-bar-chart works!\r\n</p>\r\n"